module.exports = __webpack_public_path__ + "media/images/flavours/icon-sec_dark-d3b40a5a3013560ceffbc4160534c944.png";